export const SUBMIT_NEW_QUESTION = 'SUBMIT_NEW_QUESTION';
export const SET_USER_CREATED_QUESTIONS = 'SET_USER_CREATED_QUESTIONS';
export const SET_IS_USER_QUESTIONS_LOADING = 'SET_IS_USER_QUESTIONS_LOADING';
export const SET_USER_QUESTIONS_MESSAGE = 'SET_USER_QUESTIONS_MESSAGE';
export const GET_USER_SUBMITTED_QUESTIONS = 'GET_USER_SUBMITTED_QUESTIONS';
export const DELETE_USER_SUBMITTED_QUESTION = 'DELETE_USER_SUBMITTED_QUESTION';
export const SET_DELETE_STATUS_MESSAGE = 'SET_DELETE_STATUS_MESSAGE';
export const EDIT_SUBMIT_QUESTION = 'EDIT_SUBMIT_QUESTION';
export const SET_SELECTED_QUESTION = 'SET_SELECTED_QUESTION';
